import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Product} from "../../Models/product";



@Component({
    template: `

<!--<app-detail-page [product]="product"></app-detail-page>     -->
    `,
    standalone: false
})
export class ProductComponent implements OnInit {

  product: Product[] = [];


  constructor(private route: ActivatedRoute)  {}


  ngOnInit(): void {
    this.route.data.subscribe((data : any) => {
    this.product = data.detail.body;

  })}



}
